import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import React from 'react'

import isAppDevelopment from './src/features/app/utils/isAppDevelopment'
import bugsnagEventFilter from './src/utils/bugsnagEventFilter'
import redactBugsnagEvent, {
  redactedKeys,
} from './src/utils/redactBugsnagEvent'

Bugsnag.start({
  apiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY,
  releaseStage: isAppDevelopment()
    ? 'development'
    : process.env.NEXT_PUBLIC_ENVIRONMENT,
  // Errors from local development only add noise in Bugsnag
  ...(isAppDevelopment() && { enabledReleaseStages: [] }),
  appVersion: process.env.NEXT_PUBLIC_APP_VERSION,
  plugins: [new BugsnagPluginReact(React)],
  // Don't store a persistent device ID in localStorage: it isn't needed for
  // error reporting and would otherwise need cookie consent
  generateAnonymousId: false,
  maxBreadcrumbs: 50,
  // Every type except `log`: console output on the payment pages includes
  // whatever the payment SDKs write there, which can't be reviewed. The app's
  // own logger breadcrumbs are left explicitly and still recorded
  enabledBreadcrumbTypes: [
    'error',
    'manual',
    'navigation',
    'process',
    'request',
    'state',
    'user',
  ],
  redactedKeys,
  onError: [bugsnagEventFilter, redactBugsnagEvent],
})

export default Bugsnag
